<template>
  <div class="search-recommendation">
    <navbar-favorite-search></navbar-favorite-search>
    <div v-if="programSearchRecommendation.length" class="w-100">
      <div class="search-header">
        <div class="font-label-xl-sb">Program Rekomendasi</div>
        <s-button
          id="navbar-recommendation-to-search-program"
          tag="router-link"
          variant="text"
          cluster="k"
          to="/program?ref=prakerja-pencarian-ads"
          class="text-decoration-none"
          @click.native="fireAnalytics('prakerja_search_program_rek_more_click', {})"
        >
          Lihat Semua
        </s-button>
      </div>
      <navbar-recommendation-card
        v-for="program in programSearchRecommendation"
        :key="program.id"
        :avatar="program.avatar"
        :title="program.name"
        :creator="program.creator"
        :to="`/program/${program.slug}?ref=prakerja-pencarian-ads`"
        @click.native="fireAnalytics('prakerja_search_program_rek_click', {program_id: program.id})"
      ></navbar-recommendation-card>
    </div>
    <div v-if="institutionSearchRecommendation.length" class="w-100" @click.prevent="closeNavbarRecommendation">
      <div class="search-header">
        <div class="font-label-xl-sb">Lembaga Favorit</div>
        <s-button
          id="navbar-recommendation-to-all-mitra"
          tag="router-link"
          variant="text"
          cluster="k"
          to="/mitra/all?ref=prakerja-pencarian-ads"
          class="text-decoration-none"
          @click.native="fireAnalytics('prakerja_search_lembaga_fav_more_click', {})"
        >
          Lihat Semua
        </s-button>
      </div>
      <navbar-recommendation-card
        v-for="institution in institutionSearchRecommendation"
        :key="institution.id"
        :avatar="institution.logo"
        :title="institution.name"
        :program-count="institution.prakerja_program_count"
        :to="`/mitra/${institution.slug}?ref=prakerja-pencarian-ads`"
        variant="institution"
        @click.native="fireAnalytics('prakerja_search_lembaga_fav_click', {lembaga_id: institution.id})"
      ></navbar-recommendation-card>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect'

import NavbarFavoriteSearch from '@/components/homepage/NavbarFavoriteSearch.vue'
import NavbarRecommendationCard from '@/components/navbar/NavbarRecommendationCard.vue'

import { mapState } from 'vuex'

export default {
  components: {
    NavbarFavoriteSearch,
    NavbarRecommendationCard
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('discovery', ['institutionSearchRecommendation', 'programSearchRecommendation']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    closeNavbarRecommendation () {
      this.$emit('activateOverlay', false)
      this.$store.commit('discovery/SET_IS_OPEN_NAVBAR_RECOMMENDATION', false)
    },
    fireAnalytics (eventName, additionalParams) {
      window.firebaseAnalytics.logEvent(eventName, {
        page_referrer: window.location.href,
        user_id: this.userInfo.id || null,
        user_profession: this.userInfo.profession_name || null,
        user_year_level: this.userInfo.year_level_name || null,
        user_is_admin: this.userInfo.is_admin ?? false,
        source: isMobile ? 'mweb_prakerja' : 'web_prakerja',
        ...additionalParams
      })
    }
  }
}
</script>

<style scoped>
.search-recommendation {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 92vh;
  top: var(--mobile-navbar-max-height);
  left: 0;
  padding: 16px 12px;
  overflow: auto;
  width: 100%;
  background: var(--color-ui-text-white);
  color: var(--color-text-primary);
}

.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (min-width: 1024px) {
  .search-recommendation {
    border-radius: 10px;
    position: absolute;
    top: 0;
    padding: 24px;
    height: 520px;
    box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.10);
  }

  .search-header {
    gap: 10px;
    justify-content: flex-start;
  }
}
</style>
